import { alpha } from '@mui/material/styles';

// Modern minimal palette — Tailwind-inspired slate neutrals + sky primary

const GREY = {
  0: '#FFFFFF',
  100: '#F8FAFC',
  200: '#F1F5F9',
  300: '#E2E8F0',
  400: '#CBD5E1',
  500: '#94A3B8',
  600: '#64748B',
  700: '#475569',
  800: '#1E293B',
  900: '#0F172A',
};

const PRIMARY = {
  lighter: '#E0F2FE',
  light: '#7DD3FC',
  main: '#0EA5E9',
  dark: '#0369A1',
  darker: '#0C4A6E',
  contrastText: '#fff',
};

const SECONDARY = {
  lighter: '#EDE9FE',
  light: '#A78BFA',
  main: '#7C3AED',
  dark: '#5B21B6',
  darker: '#3B0764',
  contrastText: '#fff',
};

const INFO = {
  lighter: '#DBEAFE',
  light: '#60A5FA',
  main: '#3B82F6',
  dark: '#1D4ED8',
  darker: '#172554',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#DCFCE7',
  light: '#86EFAC',
  main: '#22C55E',
  dark: '#15803D',
  darker: '#14532D',
  contrastText: '#fff',
};

const WARNING = {
  lighter: '#FEF3C7',
  light: '#FCD34D',
  main: '#F59E0B',
  dark: '#B45309',
  darker: '#78350F',
  contrastText: '#fff',
};

const ERROR = {
  lighter: '#FEE2E2',
  light: '#FCA5A5',
  main: '#EF4444',
  dark: '#B91C1C',
  darker: '#7F1D1D',
  contrastText: '#fff',
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: GREY[200],
  text: {
    primary: GREY[900],
    secondary: GREY[600],
    disabled: GREY[400],
  },
  background: {
    paper: '#fff',
    default: GREY[100],
    neutral: GREY[100],
  },
  action: {
    active: GREY[600],
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.12),
    disabled: alpha(GREY[500], 0.6),
    disabledBackground: alpha(GREY[500], 0.16),
    focus: alpha(GREY[500], 0.2),
    hoverOpacity: 0.06,
    disabledOpacity: 0.48,
  },
};

export default palette;
